import { API_ROUTES } from '@/constants/apiRoutes';
import { PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { GetMainPageStoreListParams, StoreList } from './storeList.types';

export const getMainPageStoreList = (client: AxiosInstance) => async (params: GetMainPageStoreListParams) => {
  return (await client.get<PaginatedApiResponse<StoreList[]>>(API_ROUTES.GET_MAIN_PAGE_STORE, { params })).data;
};

export const storeListQueries = {
  all: () => ['main-page-stores'],
  list: (params: GetMainPageStoreListParams) =>
    queryFactoryOptions<PaginatedApiResponse<StoreList[]>>({
      queryKey: [...storeListQueries.all(), 'list', params],
      queryFn: (client: AxiosInstance) => () => getMainPageStoreList(client)(params),
    }),
};
